import React, { } from "react";
import { ProgressBar, Button, Toast } from "react-bootstrap";
import { ActionHandlerFunction } from "@preveil-api";
import { DriveUIActionTypes, SearchProgressValues, SearchErrorCodes, DriveSearchMessages, DriveSearchLimits, MessageAnchors, AppConfiguration } from "src/common";

type AllProps = {
  search_term?: string;
  progress: number;
  counts: number;
  error?: SearchErrorCodes;
  handleAction: ActionHandlerFunction;
}

function SearchFooterComponent(props: AllProps) {
  const { counts, progress, search_term, error, handleAction } = props;

  return <div className="search-footer">
    <div>
      {
        counts < DriveSearchLimits.LIVE_QUERY_LIMIT &&
        <div className="progress-box">
          <b>{progress}%</b>
          <ProgressBar now={progress} animated />
        </div>
      }

      {
        !!error ?
          <Toast bg="warning" show={true} >
            <Toast.Body>
              {DriveSearchMessages.footer_default}
            </Toast.Body>
          </Toast> :
          counts >= DriveSearchLimits.LIVE_QUERY_LIMIT ?
            <Toast bg="warning" show={true} >
              <Toast.Body>
                <span dangerouslySetInnerHTML={{ __html: DriveSearchMessages.live_query_limit_reached.replace(MessageAnchors.item_count, counts.toString()) }}></span>
              </Toast.Body>
            </Toast> :
            progress === SearchProgressValues.complete ? (!!search_term ?
              <p>Displaying <b>{counts}</b> {counts > 1 ? "results" : "result"} for <b>"{search_term}"</b></p> :
              <p>No matching results found for your search</p>) :
              <p className="disclaimer"><b>{counts}</b> {counts > 1 ? "results" : "result"} found</p>
      }

    </div>
    <div className="btn-panel">
      {
        // NOTE: Only render this button during development mode for db clean up
        AppConfiguration.isDevelopmentRunMode() &&
        <Button
          variant="no-outline-primary"
          onClick={() => handleAction({ actionType: DriveUIActionTypes.Destroy })} >Reset Search</Button>
      }
      <Button
        variant="no-outline-primary"
        onClick={() => handleAction({ actionType: DriveUIActionTypes.Reset })} >Cancel</Button>
    </div>
  </div>;
}

export default React.memo(SearchFooterComponent);
